import * as React from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { hot } from "react-hot-loader";

import { feedAvailable, caseAvailable } from "../../lib/i18n";
import { RootState } from "../../state";
import { countrySelector, localeSelector } from "../../common/selectors";
import { draftCompanySelector, editModeSelector } from "../selectors";
import { loadCompanyShowWorker, draftCompanyUpdated } from "../actions";
import { modalOpened } from "../../common/actions/Modal";
import Translate from "../../common/components/Translate";
import SectionNavigator from "../../common/components/SectionNavigator";
import SectionAsideNav from "./organisms/SectionAsideNav";
import MissionSection from "./MissionSection";
import ProjectsSectionContainer from "./ProjectsSectionContainer";
import MembersSectionContainer from "./MembersSectionContainer";
import ValuesSectionContainer from "./ValuesSectionContainer";
import PortfolioSectionContainer from "./PortfolioSectionContainer";
import FeaturedPostsSectionContainer from "./FeaturedPostsSectionContainer";
import BasicInfoSection from "./BasicInfoSection";

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class ShowContainer extends React.Component<Props> {
  public static async fetchInitialData(getState: () => RootState, dispatch: Dispatch<RootState>) {
    const company = draftCompanySelector(getState());
    await dispatch(loadCompanyShowWorker(company.id));
  }

  public onOpenEditBasicInfoModal = () => {
    this.props.modalOpened({
      name: "companies/edit-basic-info",
    });
  };

  public onChangeCompany = (company: FirstArg<typeof draftCompanyUpdated>) => {
    this.props.draftCompanyUpdated(company);
  };

  public render() {
    const { company, locale, country, editMode } = this.props;

    return (
      <SectionNavigator
        renderNav={props => (
          <SectionAsideNav
            {...props}
            navTitle={<Translate id="company.nav.home" />}
            activeColor={company.font_color_code}
          />
        )}
      >
        <MissionSection
          locale={locale}
          country={country}
          company={company}
          editable={editMode}
          onChange={this.onChangeCompany}
        />
        {(feedAvailable(country) || company.is_international_feed) && (
          <FeaturedPostsSectionContainer showAllPostsLink />
        )}
        <ValuesSectionContainer />
        {caseAvailable(country) && <PortfolioSectionContainer locale={locale} editable={editMode} />}
        <MembersSectionContainer locale={locale} editable={editMode} />
        <ProjectsSectionContainer locale={locale} editable={editMode} />
        <BasicInfoSection
          locale={locale}
          company={company}
          editable={editMode}
          onEdit={this.onOpenEditBasicInfoModal}
        />
      </SectionNavigator>
    );
  }
}

function mapStateToProps(state: RootState) {
  return {
    company: draftCompanySelector(state),
    editMode: editModeSelector(state),
    country: countrySelector(state),
    locale: localeSelector(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>) {
  return bindActionCreators(
    {
      loadCompanyShowWorker,
      draftCompanyUpdated,
      modalOpened,
    },
    dispatch
  );
}

const connected = connect(mapStateToProps, mapDispatchToProps)(ShowContainer);
export default hot(module)(connected);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ShowContainer.tsx